export default __webpack_public_path__ + "static/media/SOLUTIONS-FOR-YOU.c536a267.png";